import { TFunction } from 'i18next';
import _get from 'lodash/get';
import { SiteArea } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import TextLinkCell from '@lib/components/Table/commonComponents/TextLinkCell/TextLinkCell';
import { CellProps } from '@lib/components/Table/types';
import { ChipTypes } from '@lib/components/Chip/Chip';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';

type ColumnsArgs = {
  onViewHandler: (item: SiteArea) => void;
  t: TFunction<'translation', undefined>;
};

export default function getAreasColumns({ onViewHandler, t }: ColumnsArgs) {
  return [
    {
      id: 'code',
      Header: t('area-code'),
      accessor: 'code',
      Cell: (props: CellProps<SiteArea>) => <TextCell {...props} />,
      width: 160,
      sortable: true,
    },
    {
      id: 'name',
      Header: t('area-name'),
      accessor: 'name',
      Cell: (props: CellProps<SiteArea>) => (
        <TextLinkCell {...props} onClick={() => onViewHandler(props?.item)} />
      ),
      sortable: true,
      maxWidth: 300,
    },
    {
      id: 'siteCode',
      Header: t('site-code'),
      accessorFn: (props: CellProps<SiteArea>) =>
        _get(props, 'item.site.code', ''),
      Cell: (props: CellProps<SiteArea>) => <TextCell {...props} />,
      minWidth: 182,
      maxWidth: 182,
      width: 182,
    },
    {
      id: 'siteName',
      Header: t('site'),
      Cell: (props: CellProps<SiteArea>) => {
        const label = _get(props, 'item.site.name', '');
        if (!label) return '-';
        return <ChipCell label={label} type={ChipTypes.chipGray} />;
      },
      sortable: true,
      width: 300,
      maxWidth: 350,
    },
    {
      id: 'sectorName',
      Header: t('sector'),
      Cell: (props: CellProps<SiteArea>) => {
        const label = _get(props, 'item.site.sector.name', '');
        const color = _get(
          props,
          'item.site.sector.color',
          ChipTypes.chipGray,
        ) as ChipTypes;
        if (!label) return '-';
        return <ChipCell label={label} type={color} />;
      },
      sortable: true,
      width: 300,
      maxWidth: 350,
    },
  ];
}
